import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {AdminSignInComponent} from './sign-in/admin-sign-in.component';


/**
 * Routes available in application
 *
 * @usageNotes
 * path: '', redirectTo: '/sign-in' - redirect to sign-in form
 * path: '', loadChildren: 'src/app/auth/auth.module#AuthModule' - lazy loading of auth module
 * {@link https://angular.io/guide/router}
 * {@link https://angular.io/guide/lazy-loading-ngmodules}
 */
const routes: Routes = [
  {path: 'sign-in', component: AdminSignInComponent},
  {path: '**', redirectTo: '/sign-in', pathMatch: 'full'}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
